Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SimplecastEpisode", {
  enumerable: true,
  get: function get() {
    return _simplecastEpisode.SimplecastEpisode;
  }
});
var _simplecastEpisode = require("./simplecast-episode");